import { ComboItem } from "../../../../model";
import { IPaginatedResponse, IResponse } from "../../../model";
import ServiceBase from "../../../servicebase";
import { IProveedorPais, IProveedorRegion, IProveedorContacto, IVoucherTemplate, ISociedad } from "../model";
import { IProveedor } from "../model/IProveedor";

export default class ProveedorService extends ServiceBase {
  //ya migrados
  combo = (data: { activos?: boolean, includeTodos?: boolean, includeNinguno?: boolean, includeId?: number }) => 
    this.GetFetch<IResponse<ComboItem[]>>('clientes/cliente/combo', data);





  all = () : Promise<IResponse<IProveedor[]>> => 
    this.GetFetch<IResponse<IProveedor[]>>('entity/proveedor/all', {});

  get = (data:{ id?: number }) : Promise<IResponse<IProveedor>> => 
    this.GetFetch<IResponse<IProveedor>>('entity/proveedor', data);

  find = (data:{ pageIndex?: number, pageSize?: number, sort?: string, id?: number, nombre?: string, pais?: string, activo?: boolean }) : Promise<IPaginatedResponse<IProveedor>> => 
    this.GetFetch<IPaginatedResponse<IProveedor>>('entity/proveedor/find', data);

  upsert = (data:IProveedor) : Promise<IResponse<IProveedor>> => 
    this.PostFetch<IResponse<IProveedor>>('entity/proveedor', data);

  delete = (data:{ id:number, undelete?: boolean}) : Promise<IResponse<void>> => 
    this.DeleteFetch<IResponse<void>>('entity/proveedor', data);

  paises_all = (data: { idProveeedor?: number }) : Promise<IResponse<IProveedorPais[]>> =>
    this.GetFetch<IResponse<IProveedorPais[]>>('entity/proveedor/paises/all', data);

  regiones_all = (data: { idProveeedor?: number }) : Promise<IResponse<IProveedorRegion[]>> =>
    this.GetFetch<IResponse<IProveedorRegion[]>>('entity/proveedor/regiones/all', data);

  contactos_all = (data: { idProveeedor?: number }) : Promise<IResponse<IProveedorContacto[]>> =>
    this.GetFetch<IResponse<IProveedorContacto[]>>('entity/proveedor/contactos/all', data);

  vouchertemplates_all = (data: { idProveeedor?: number }) : Promise<IResponse<IVoucherTemplate[]>> =>
    this.GetFetch<IResponse<IVoucherTemplate[]>>('entity/proveedor/vouchertemplates/all', data);

  sociedades_all = (data: { idProveeedor?: number }) : Promise<IResponse<ISociedad[]>> =>
    this.GetFetch<IResponse<IVoucherTemplate[]>>('entity/proveedor/sociedades/all', data);
}
